import styled from "styled-components";

// Contenedor principal para el checkbox
export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  gap: 5px;
  .txt-title {
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 700;
    font-size: 12px;
    text-align: left;
    margin-bottom: 5px;
  }
  .txtError {
    margin-top: 6px;
    font-family: "Roboto", Helvetica, sans-serif;
    font-weight: 400;
    font-size: 12px;
    color: rgb(167, 35, 35);
    text-align: left;
  }
`;

// Etiqueta para el checkbox
export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  margin: 0;
  padding: 0;
`;

// Estilos para el input checkbox
export const CheckboxInput = styled.input`
  display: none; // Escondemos el checkbox por defecto
`;

// Estilos para el icono personalizado del checkbox
export const CheckboxIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background-color: ${(props) => (props.checked ? "#4caf50" : "#ccc")};
  border-radius: 4px;
  position: relative;
  transition: background-color 0.3s ease;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-color: white;
    border-radius: 50%;
    opacity: ${(props) => (props.checked ? 1 : 0)};
    transition: opacity 0.3s ease;
  }
`;
